import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a60c5d42")

_pushScopeId("data-v-a60c5d42")
const _hoisted_1 = { class: "analysisAnswer" }
const _hoisted_2 = { class: "question" }
const _hoisted_3 = {
  key: 0,
  class: "score"
}
const _hoisted_4 = { class: "score-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_question_modules = _resolveComponent("question-modules")
  const _component_the_analysis = _resolveComponent("the-analysis")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_the_analysis, {
      "job-id": _ctx.jobId,
      view: _ctx.view,
      "question-loading": _ctx.questionLoading,
      onHandleSubmit: _ctx.onSubmit
    }, {
      question: _withId(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moduleList, (modules, i) => {
            return (_openBlock(), _createBlock(_component_question_modules, _mergeProps({
              key: modules.id,
              class: "modules"
            }, modules, {
              seq: i+1,
              onReload: _ctx.initQuestion
            }), null, 16, ["seq", "onReload"]))
          }), 128)),
          (_ctx.view === "see")
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.analysisScore) + "分", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["job-id", "view", "question-loading", "onHandleSubmit"])
  ]))
})